import { ProductGame } from "@/@types/common";

export enum VirtualCurrencyCode {
  RP = "RP",
  WC = "WC",
  VP = "VP",
  COIN = "COIN",
}

export enum VirtualCurrencies {
  RP = "RP",
  WC = "WC",
  VP = "VP",
  COIN = "COIN",
  NCT = "NCT",
}

export const VirtualCurrencyCodeByProductGame: Record<ProductGame, VirtualCurrencyCode> = {
  [ProductGame.LeagueOfLegends]: VirtualCurrencyCode.RP,
  [ProductGame.Valorant]: VirtualCurrencyCode.VP,
  [ProductGame.WildRift]: VirtualCurrencyCode.WC,
  [ProductGame.LegendsOfRuneterra]: VirtualCurrencyCode.COIN,
};

export const ProductGameByVirtualCurrencyCode: Record<VirtualCurrencyCode, ProductGame> = {
  [VirtualCurrencyCode.RP]: ProductGame.LeagueOfLegends,
  [VirtualCurrencyCode.VP]: ProductGame.Valorant,
  [VirtualCurrencyCode.WC]: ProductGame.WildRift,
  [VirtualCurrencyCode.COIN]: ProductGame.LegendsOfRuneterra,
};
